import type {EditTaskFormPayload} from "./edit-task.schema";

import {editTask} from "@project/sdk/admin";
import {mutationOptions} from "@tanstack/react-query";

import {userMutationKeys} from "../../../../user-keys";

import {editTaskMapper} from "./edit-task.mapper";

/**
 * Mutation option factory for editing a task on a user.
 *
 * @param userId - The ID of the user who owns the task
 * @param taskId - The ID of the task to edit
 */
export function editTaskMutationOptions(userId: string, taskId: string) {
  return mutationOptions({
    mutationFn: (payload: EditTaskFormPayload) => {
      const request = editTaskMapper.toSdk(payload);

      return editTask(userId, taskId, request);
    },
    mutationKey: userMutationKeys.editTask(),
  });
}
